<ui-image-info
  imageSrc="icon_404"
  i18n-header="@@PAGE_NOT_FOUND"
  header="Oops... Page not Found"
  [descriptions]="descriptionImageInfo"
  [maxWidth]="400"
></ui-image-info>
